/**
 * CheckFeature
 */

define(
        'checkFeatures',
        ['devicejs'],
        function (device) {
            "use strict";
            //    methods
            /**
             * Vérifier si le navigateur gère le type HTML5 donné sur un input
             * @param {string} type Type HTML5 (number, date, time,
             * datetime-local...)
             * @returns {Boolean} Retourne vrai si le navigateur gère ce type,
             * false sinon
             */
            function checkInput(type)
            {
                var input = document.createElement("input");
                input.setAttribute("type", type);
                var result = (input.type === type);
                if (type === 'date') {
                    var notADateValue = 'not-a-date';
                    input.setAttribute('value', notADateValue);
                    result = (input.value !== notADateValue);
                }

                return result;
            }

            /**
             * Check if the browser support the maxlength attribute for an input (input or textarea)
             * @param {string} typeInput Type of input (input or textarea). textarea by default.
             * @returns {Boolean} Returns true if the input supports the maxlgenth attribute, else returns false
             */
            function checkMaxlenghtSupport(typeInput)
            {
                if (typeof typeInput === "undefined") {
                    typeInput = "textarea";
                }

                var result;
                if (!("maxLength" in document.createElement(typeInput))) {
                    result = false;
                } else {
                    result = true;
                }

                return result;
            }

            /**
             * Vérifier si le device a un petit écran (<= à  992 x 700)
             * @returns {Boolean} Retourn vrai si on est sur un petit device,
             * false sinon
             */
            function isSmallDevice()
            {
                var result = device.mobile();
//                if (!result) {
//                    var screen_md_min = 992; // 1024 same as height problem
//                    var result = (screen.width <= screen_md_min)
//                            || (screen.height <= 700);
//                    //800 too small for my fucking shitty screen
//                }
                return result;
            }

            /**
             * Check if screen could pivotate (smartphone or tablet)
             * @returns {Boolean} Return true or false
             */
            function isPhoneOrTablet()
            {
                var result = device.mobile() || device.tablet();
                //    var result = false;
                //
                //    // Test orientation de l'écran
                //    if (typeof window.orientation !== "undefined") {
                //        result = true;
                //    }

                return result;
            }

            function isIos() {
                var isIos = device.ios();

                return isIos;
            }

            //    exposed public method
            return {
                checkInput: checkInput,
                checkMaxlenghtSupport: checkMaxlenghtSupport,
                isSmallDevice: isSmallDevice,
                isPhoneOrTablet: isPhoneOrTablet,
                isIos: isIos
            };
        },
        function (err) {
            console.error("ERROR: ", err.requireType);
            console.error("MODULES: ", err.requireModules);
        }
);

